// Unsaved survey answers are backed up in sessionStorage so a reload doesn't
// lose them. The tab outlives a login, so a draft is keyed to the company and
// employee who typed it, and every draft is wiped whenever the tab's identity
// changes (login, logout, session expiry, impersonation start or end). Before
// QA-02 the key was the survey id alone and survived logout, so the next
// employee in the same tab could see the previous one's answers.
const SURVEY_DRAFT_PREFIX = 'survey-answers-draft:';

export function surveyDraftKey(
  companyId: string | null | undefined,
  employeeId: string | null | undefined,
  surveyId: string | null | undefined
): string | null {
  if (!companyId || !employeeId || !surveyId) return null;
  return `${SURVEY_DRAFT_PREFIX}${companyId}:${employeeId}:${surveyId}`;
}

/** Removes every survey draft in this tab, including old survey-id-only keys. */
export function clearSurveyDrafts(storage?: Storage): void {
  try {
    const target = storage ?? window.sessionStorage;
    const keys: string[] = [];
    for (let i = 0; i < target.length; i += 1) {
      const key = target.key(i);
      if (key?.startsWith(SURVEY_DRAFT_PREFIX)) keys.push(key);
    }
    keys.forEach((key) => target.removeItem(key));
  } catch {
    // Storage unavailable: there is nothing readable to leak either.
  }
}
